export enum BeautifyConfig {
  Instagram = 'Instagram',
  Default = 'Default',
}
